import { render } from "./WorkflowSteps.vue?vue&type=template&id=67c53656&scoped=true"
import script from "./WorkflowSteps.vue?vue&type=script&lang=js"
export * from "./WorkflowSteps.vue?vue&type=script&lang=js"

import "./WorkflowSteps.vue?vue&type=style&index=0&id=67c53656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c53656"]])

export default __exports__